import { render, staticRenderFns } from "./ContactGwangjuPage.vue?vue&type=template&id=5a438b44&scoped=true&"
import script from "./ContactGwangjuPage.vue?vue&type=script&lang=js&"
export * from "./ContactGwangjuPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a438b44",
  null
  
)

export default component.exports